export interface UploadedFile {
  id: number;
  name: string;
  size: string;
  uploadDate: string;
  file: File;
}

export interface InputValueProjectForm {
  project_name: string;
  fiscal_year: number;
  start_date: string; // or Date
  end_date: string; // or Date
  budget: number;
  edpex_project_strategic_work: string;
  edpex_project_ongoing: string;
  project_type: string;
  project_status: string;
  id_project_continue: number;
  responsible_work: string;
  responsible_department: string;
  responsible_director: string;
  edpex_mission: string;
  edpex_criteria: number;
  edpex_criteria_sub: number;
  objective: string;
  target_group: string;
  edpex_result: string;
  indicatorList: any[];
  spendingInfo: any[];
  responsiblePersons: any[];
  description: string;
  edpex_project_user_responsible?: string,
  edpex_project_department_responsible?: string,
  edpex_project_division_responsible?: string,
}

export const defualtValueProjectForm = {
  project_name: "",
  fiscal_year: 0,
  start_date: "",
  end_date: "",
  budget: 0,
  edpex_project_strategic_work: "",
  edpex_project_ongoing: "",
  project_type: "",
  project_status: "",
  id_project_continue: 0,
  responsible_work: "",
  responsible_department: "",
  responsible_director: "",
  edpex_mission: "",
  edpex_criteria: 0,
  edpex_criteria_sub: 0,
  objective: "",
  target_group: "",
  edpex_result: "",
  indicatorList: [],
  spendingInfo: [],
  responsiblePersons: [],
  description: "",
  edpex_project_department_responsible: "",
  edpex_project_division_responsible: "",
  edpex_project_user_responsible: "",
};

export interface ProjectSubmissionData {
  edpex_project_name: string;
  fiscal_year: number;
  edpex_project_start_date: string;
  edpex_project_end_date: string;
  edpex_project_budget: number;
  edpex_project_strategic_work: string;
  edpex_project_ongoing: string;
  id_edpex_project_ref: number;
  id_department?: string;
  id_department_ref?: string;
  id_employee?: string;
  id_edpex_mission: number;
  id_edpex_standard_point: number;
  id_edpex_standard_point_detail: number;
  edpex_project_objective: string;
  edpex_project_target_group: string;
  edpex_project_result: string;
  edpex_project_status: string | boolean;
  edpex_project_remark: string;
  edpex_project_indicators: any[];
  edpex_project_budgets: any[];
  edpex_project_responsible: any[];
  id_edpex_project_files: number[];
  edpex_project_department_responsible?: string,
  edpex_project_division_responsible?: string,
  edpex_project_user_responsible?: string,
}
